import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Styles as S } from '~/pages/history/multipleChoice/studyGoal/styles'
import { Button } from '~/shared/components/Button'
import { OptionType } from '~/shared/constants/commonConstants'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'What topics are you interested in?'

const OPTIONS = [
  { key: 'history', i18nKey: 'first' },
  { key: 'geography', i18nKey: 'second' },
  { key: 'productivity', i18nKey: 'third' },
  { key: 'psychology', i18nKey: 'fourth' },
  { key: 'biology', i18nKey: 'fifth' },
  { key: 'social', i18nKey: 'sixth' },
  { key: 'money', i18nKey: 'seventh' },
  { key: 'ai', i18nKey: 'eighth' },
  { key: 'growth', i18nKey: 'ninth' },
  { key: 'other', i18nKey: 'tenth' },
] as const

const TopicsArt = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('art')
  const [answers, setAnswers] = useState<string[]>([])

  const handleOptionChange = (optionValue: string, isChecked: boolean) => {
    setAnswers((prev) =>
      isChecked
        ? [...prev, optionValue]
        : prev.filter((item) => item !== optionValue),
    )
  }

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ScrollContent>
          <S.Content>
            <S.Title>
              <Trans ns="art" i18nKey="onboarding.artTopics.title" />
            </S.Title>
          </S.Content>

          <S.OptionContainer>
            {OPTIONS.map(({ key, i18nKey }) => {
              const optionText = t(`onboarding.artTopics.options.${i18nKey}`)
              const spaceIndex = optionText.indexOf(' ')
              const emoji =
                spaceIndex !== -1 ? optionText.slice(0, spaceIndex) : optionText
              const text =
                spaceIndex !== -1 ? optionText.slice(spaceIndex + 1) : ''

              return (
                <S.StyledOption
                  key={key}
                  $isShortOption
                  type={OptionType.CHECKBOX}
                  value={key}
                  name="topicsArt"
                  onChange={handleOptionChange}
                  checked={answers.includes(key)}
                >
                  <S.Value>
                    <S.OptionIcon>{emoji}</S.OptionIcon>
                    <S.ValueText>{text}</S.ValueText>
                  </S.Value>
                </S.StyledOption>
              )
            })}
          </S.OptionContainer>
        </S.ScrollContent>

        <S.ButtonContainer>
          <Button
            type="button"
            onClick={() => handleContinue(answers)}
            disabled={!answers.length}
          >
            <Trans i18nKey="actions.continue" />
          </Button>
        </S.ButtonContainer>
      </S.StyledContainer>
    </S.Root>
  )
}

export default TopicsArt
